import { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import { AddMarginService } from "../../services/AddMarginService";
import * as BullCache from "../../util/BullCache";
import MarketDropdown from "../components/MarketDropdown";
import ScriptDropdown from "../components/ScriptDropdown";

function AddMargin() {
  const [expiryDates, setExpiryDates] = useState("");
  const [margins, setMargins] = useState("");
  const [selectedMarket, setSelectedMarket] = useState(""); 
  const [selectedScript, setSelectedScript] = useState("");

  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');
  
  const handleMarketChange = (market) => {
    setSelectedMarket(market); 
};

const handleScriptChange = (script) => {
    setSelectedScript(script); 
};
const handleScriptReset = () => {
  setSelectedScript(null); 
};
  const handleMarginChange = (e) => setMargins(e.target.value);
  const handleDateChange = (e) => setExpiryDates(e.target.value);

  const handleSubmit = () => {
    
      if (!selectedMarket || !selectedScript || !expiryDates || !margins) {
                  Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Please Select All Fields!",
                  });
                  return;
              }

              const date = new Date(expiryDates);
              const formattedExpiryDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;

    const formData = {
      adminId: user.adminId,
      segment: selectedMarket,
      script: selectedScript,
      expiryDate: formattedExpiryDate,
      margin: margins,
    };

   
      AddMarginService.addMargin(formData).then(res => {
        if (res.code === 1) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Added Successfully!",
          });
          setExpiryDates('');
          setSelectedMarket('');
      
          setSelectedScript('');
          setMargins('');
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:  "Something went wrong, please try again.",
          });
        }
    });
  };


  return (
    <div>
      <Card>
        <Card.Body>

          <Row className="mt-3">
            <Col className="col-4">
            <b className='fss-05'>MARKET</b>
              <MarketDropdown
                allScripts={allScripts}
                onMarketChange={handleMarketChange}
                selectedMarket={selectedMarket}
                onScriptReset={handleScriptReset}
              />
            </Col>

            <Col className="col-4">
            <b className='fss-05'>SCRIPT NAME</b>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col className="col-4">
              <b className="fss-05">EXPIRY DATE:</b>
              <input
                type="date"
                className="form-control bg-light text-black"
                value={expiryDates}
                onChange={handleDateChange}
              />
            </Col>

            <Col className="col-4">
              <b className="fss-05">MARGIN:</b>
              <input
                type="number"
                className="form-control bg-light text-black"
                value={margins}
                onChange={handleMarginChange}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col sm={3}></Col>
            <Col sm={6}>
              <Button
                variant="success"
                className="me-2 w-25"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default AddMargin;
